<template>
  <form @submit.prevent="vLaunchOrderResearch">
    <div class="order-research">
      <div class="form-field">
        <label>{{$_('satab_number_order')}}</label>
         <Input
          :type="'text'"
          :ref="'fncde'"
          @typing="vSelectedStore('fncde', $event)"
        />
      </div>
      <div class="form-field">
        <label>{{$_('customer_order_reference')}}</label>
        <Input
          :type="'text'"
          :ref="'fref'"
          @typing="vSelectedStore('fref', $event)"
        />
      </div>
      <div class="form-field">
        <label>{{$_('satab_product_reference')}}</label>
        <SelectAutocomplete
          delay="300"
          :itemoption="['TMOD', 'TMOD']"
          @autocomplete:selected="vSelectedStore('fmod', $event.TMOD)"
          :ajax="true"
          :func="vSearchProduct"
        />
      </div>
      <div class="form-field">
        <label>{{$_('color')}}</label>
        <SelectAutocomplete
          :itemoption="['TCOL', 'TCOL']"
          @autocomplete:selected="vSelectedStore('fcol', $event.TCOL)"
          :ajax="true"
          :func="vSearchColor"
        />
      </div>
      <div class="form-field">
        <label>{{$_('status')}}</label>
        <SelectMultiple 
        class="no-margin" 
          :placeholder="'Statut'" 
          :itemoption="['TSTATUS', 'TMOTCLE']"
          @selectmultiple:selecting="vSelectStatus($event)"
          :data="search_data.status"
          :preselected="getStatus"
        />   
      </div>
      <div class="form-field">
        <label>{{$_('period')}}</label>
        <DatePicker 
          :interval="true"
          @datepicker:select="vSelectedStore('fdate', $event)" 
        />
      </div>
      <div class="form-field btn-launch-container">
        <button class="btn">{{$_('research_button')}}</button>
      </div>
    </div>
  </form>
</template>

<script>
import DatePicker from "@/common/components/widget/DatePicker";
import Select from "@/common/components/widget/Select";
import SelectMultiple from "@/common/components/widget/SelectMultiple";
import SelectAutocomplete from "@/common/components/widget/Autocomplete/SelectAutocomplete";
import orderService from '../services/orderService.js';
import Input from "@/common/components/widget/Input/Input";

export default {
  data() {
    return {
      search_data: {
        colors: Array(),
        status: [
          {TSTATUS: 'solde', TMOTCLE: this.$_('sale')},
          {TSTATUS: 'supprime', TMOTCLE: this.$_('deleted')},
          {TSTATUS: 'en_cours', TMOTCLE: this.$_('in_progress')}
        ],
        product: Array(),
        customer: Array(),
      },
      status_data: {
        'en_cours': 0,
        'solde': 0,
        'supprime': 0,
      },
      init_status: ''
    }
  },
  computed: {
    getStatus() {
      return this.init_status;
    }
  },
  components: {
    DatePicker,
    SelectMultiple,
    SelectAutocomplete,
    Input
  },
  created() {

    this.$store.dispatch('commande/RESET_RESEARCH');

    this.vSearchRefCustomer();

    setTimeout(() => {
      this.init_status = 'En cours';
    }, 500);
  },
  methods: {
    vLaunchOrderResearch() {
      this.$store.dispatch('commande/LAUNCH_RESEARCH', {launch: true});
      this.$store.dispatch('commande/SELECT', {key: 'reset_order_list',  value: true});
    },
    vSelectedStore(key, value) {

      if(key === 'fdate') {
        let date_array = value.split('-'); 

        date_array.map((date, index) => {
          let date_tmp = date.trim().split('/');
          date_tmp.reverse();
          let date_format = date_tmp.join('');

          if(index === 0) {
            this.$store.dispatch('commande/SELECT', {key: 'fdate_cdemin', value: date_format});
          } else if (index === 1) {
            this.$store.dispatch('commande/SELECT', {key: 'fdate_cdemax', value: date_format});
          }
        })
      } else {
        this.$store.dispatch('commande/SELECT', {key, value});
      }
    },
    vSearchProduct(query) {
      return orderService.getProduct(query).then(res => {
        if(res.data.DS_O.OUT !== undefined) {
          return res.data.DS_O.OUT
        }
      })
    },
    vSearchColor(query) {
      return orderService.getOrderColor(query).then(res => {
        if(res.data.DS_O.OUT !== undefined) {
          return res.data.DS_O.OUT
        }
      })
    },
    vSearchRefCustomer() {
      return orderService.getRefCustomer().then(res => {
       if(res.data.DS_O !== undefined) {
          res.data.DS_O.OUT.map(obj => {
            this.search_data.customer.push(obj);
          });
        }
      })
    },
    vSelectStatus(event) {

      let status_code = '';

      if(event.type === 'check') {
        this.status_data[event.option] = 1;
      } else if (event.type === 'uncheck') {
        this.status_data[event.option] = 0;
      }
    
      Object.values(this.status_data).map(value => {
        status_code += value.toString();
      })

      this.vSelectedStore('fstatut', status_code);
    }
  }
};
</script>

<style scoped>
.order-research {
  background-color: #f5f5f5;
  padding: 20px;
  display: flex;
  flex-wrap: wrap
}
form {
  width: 1;
}
.form-field {
  margin: 5px;
}
label {
  padding-left: 20px;
}
.form-element {
  width: 200px;
}
.btn-launch-container {
  display: flex;
  justify-content: flex-end;
}
/deep/
.select-box {
  margin: 0px;
  max-width: 200px;
  min-width: 200px;
}
</style>